import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Container, Box, Typography, CircularProgress } from "@mui/material";
import LogoGrupoLae from '../../img/image_2024_04_30T07_32_45_647Z.png';
import LogoTSP from '../../img/LOGO_TSP_2.png';
import BackgroundImage from '../../img/Fondo_GRUPO_LAE.jpg';
import { ToastContainer, toast } from "react-toastify";
import { fetchSolicitarRecuperacion } from '../../../peticiones_API/PeticionesAuth';

const isTSP = window.location.hostname.startsWith('tsp.');
const Logo = isTSP ? LogoTSP : LogoGrupoLae;

const FormRecuperarPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!email || !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i.test(email)) {
            toast.error("¡Correo electrónico no válido!");
        } else {
            setLoading(true);
            try {
                const response = await fetchSolicitarRecuperacion({ email: email, origen: window.location.origin });
                console.log("response: ", response.status);
                if(response.status == 404){
                    toast.error("¡El correo electrónico no existe!");
                    return;
                }else if(response.status == 403){
                    toast.error("¡Error, el usuario no esta activo!");
                    return;
                }else if (response.status !== 200) {
                    toast.error("¡Error al enviar el correo!");
                    return;
                }else{
                    toast.success("Se ha enviado un correo para restablecer tu contraseña");
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000);
                }
            } catch (error) {
                console.log(error);
                toast.error("¡Ha ocurrido un error al enviar el correo!");
            } finally {
                setLoading(false);
            }
        }
    };

    return (

        <Box
            sx={{
                minHeight: '100vh',
                backgroundImage: `url(${BackgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2
            }}
        >

        <Container
            component="main"
            maxWidth="xs"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 2,
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: 'white',
                    width: '100%',
                    maxWidth: 360
                }}
            >
                <img src={Logo} alt="Logo" style={{ width: '100px', marginBottom: '20px' }} />
                <Typography component="h1" variant="h5">
                    Recuperar Contraseña
                </Typography>
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 1, mb: 2 }}>
                    Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo Electrónico"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, py: 1 }}
                    >
                        {loading ? (
                            <CircularProgress
                                thickness={5}
                                size={24}
                                style={{ color: '#ffffff', position: 'relative', top: 3, marginBottom: 5 }}
                            />
                        ) : (
                            'Enviar'
                        )}
                    </Button>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        align="center"
                        sx={{ mt: 1 }}
                    >
                        <Button
                            onClick={() => navigate("/login")}
                            variant="text"
                            size="small"
                        >
                            Volver al inicio de sesión
                        </Button>
                    </Typography>
                </Box>
            </Box>
        </Container>
        </Box>
    );
};

export default FormRecuperarPassword;